// Class: motion.easing._Quad.QuadEaseOut

var $global = typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : this

$global.Object.defineProperty(exports, "__esModule", {value: true});

var __map_reserved = {};

// Imports

var $hxClasses = require("./../../../hxClasses_stub").default;
function motion_easing_IEasing() {return require("./../../../motion/easing/IEasing");}

// Constructor

var QuadEaseOut = function() {
}

// Meta

QuadEaseOut.__name__ = ["motion","easing","_Quad","QuadEaseOut"];
QuadEaseOut.__isInterface__ = false;
QuadEaseOut.__interfaces__ = [(motion_easing_IEasing().default)];
QuadEaseOut.prototype = {
	calculate: function(k) {
		return -k * (k - 2);
	},
	ease: function(t,b,c,d) {
		return -c * (t /= d) * (t - 2) + b;
	}
};
QuadEaseOut.prototype.__class__ = QuadEaseOut.prototype.constructor = $hxClasses["motion.easing._Quad.QuadEaseOut"] = QuadEaseOut;

// Init



// Statics




// Export

exports.default = QuadEaseOut;